import { render, staticRenderFns } from "./ServiceNew.vue?vue&type=template&id=adb0a5c8&scoped=true&"
import script from "./ServiceNew.vue?vue&type=script&lang=js&"
export * from "./ServiceNew.vue?vue&type=script&lang=js&"
import style0 from "./ServiceNew.vue?vue&type=style&index=0&id=adb0a5c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb0a5c8",
  null
  
)

export default component.exports